import { render, staticRenderFns } from "./by-patient.vue?vue&type=template&id=7043c43d&scoped=true"
import script from "./by-patient.vue?vue&type=script&lang=js"
export * from "./by-patient.vue?vue&type=script&lang=js"
import style0 from "./by-patient.vue?vue&type=style&index=0&id=7043c43d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7043c43d",
  null
  
)

export default component.exports